var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/microphone-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone-2_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.4932 12.1599C24.9732 12.1599 24.5599 12.5733 24.5599 13.0933V15.1999C24.5599 19.9199 20.7199 23.7599 15.9999 23.7599C11.2799 23.7599 7.43991 19.9199 7.43991 15.1999V13.0799C7.43991 12.5599 7.02658 12.1466 6.50658 12.1466C5.98658 12.1466 5.57324 12.5599 5.57324 13.0799V15.1866C5.57324 20.6133 9.74658 25.0799 15.0666 25.5599V28.3999C15.0666 28.9199 15.4799 29.3333 15.9999 29.3333C16.5199 29.3333 16.9332 28.9199 16.9332 28.3999V25.5599C22.2399 25.0933 26.4266 20.6133 26.4266 15.1866V13.0799C26.4132 12.5733 25.9999 12.1599 25.4932 12.1599Z",
    fill: "#7F7D89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9998 2.66663C12.7464 2.66663 10.1064 5.30663 10.1064 8.55996V15.3866C10.1064 18.64 12.7464 21.28 15.9998 21.28C19.2531 21.28 21.8931 18.64 21.8931 15.3866V8.55996C21.8931 5.30663 19.2531 2.66663 15.9998 2.66663ZM17.7464 11.9333C17.6531 12.28 17.3464 12.5066 16.9998 12.5066C16.9331 12.5066 16.8664 12.4933 16.7998 12.48C16.2798 12.3333 15.7331 12.3333 15.2131 12.48C14.7864 12.6 14.3731 12.3466 14.2664 11.9333C14.1464 11.52 14.3998 11.0933 14.8131 10.9866C15.5998 10.7733 16.4264 10.7733 17.2131 10.9866C17.6131 11.0933 17.8531 11.52 17.7464 11.9333ZM18.4531 9.34663C18.3331 9.66663 18.0398 9.85329 17.7198 9.85329C17.6264 9.85329 17.5464 9.83996 17.4531 9.81329C16.5198 9.46663 15.4798 9.46663 14.5464 9.81329C14.1464 9.95996 13.6931 9.74663 13.5464 9.34663C13.3998 8.94663 13.6131 8.49329 14.0131 8.35996C15.2931 7.89329 16.7064 7.89329 17.9864 8.35996C18.3864 8.50663 18.5998 8.94663 18.4531 9.34663Z",
    fill: "#7F7D89"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.c1739a6e10607c71776ab20fe85bf696.svg";
export { ForwardRef as ReactComponent };